import React, { useEffect, useState } from "react";
import "../styles/JozunaSkillUpPageStyle.css";
import Specialization from "../../assets/images/skill-up-page/Specialization.svg";
import AssessmentNotFound from "../../../../assets/images/recommandation/assessmentNotFound.png";
import IndustryNotFound from "../../../../assets/images/recommandation/industryNotFound.png";
import Beginner from "../../assets/images/skill-up-page/Beginner.svg";
import Content from "../../assets/images/skill-up-page/Content.svg";
import Schedule from "../../assets/images/skill-up-page/Schedule.svg";
import PlayButton from "../../assets/images/skill-up-page/PlayButton.svg";
import NewIcon from "../../assets/images/New.svg";
import { useApi } from "../../../../service/ApiContext";
import Logger from "../../../../utils/Logger";
import { useAlert } from "../../../../components/AlertContextComponent";
import Loader from "../../../../utils/Utils";
import { videolandingPageRequest } from "../data/request/VideoLandingPageRequest";
import {
  Recommendation,
  videoLandingPageResponse,
} from "../data/response/VideoLandingPageResponse";
import VideoLandingPageClient from "../data/api/VideoLandingPageClient";

import { Button, Card, CardBody, CardText, CardTitle } from "reactstrap";
import { useNavigate } from "react-router-dom";
import { handleImageErrorCallBack } from "../../recommendation_industry_view/components/ErrorImage_PlaceHolder";
import { logActionEvent } from "../../../../analytics/analytics_utils";
import analytics_strings from "../../../../analytics/analytics_strings";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store/store";
import { CourseNameTitleTextComponent } from "../../recommendation_industry_view/components/TopicNameTittleText";

interface JozunaSkillUpProps {
  activeTab: number;
  jozunaData: Recommendation[] | null;
  industryData: Recommendation[] | null;
  jozunaDuration: number;
  industryDuration: number;
  program_title?: string;
  program_description?: string;
  jozuna_title?: string;
  jozuna_description?: string;
  jozuna_program_id?: string;
  industry_program_id?: string;
  assessmentFound?: boolean;
  type?: string;
  programDropdownComponent?: React.ReactNode;
}

const JozunaSkillUp: React.FC<JozunaSkillUpProps> = ({
  type,
  assessmentFound,
  activeTab,
  jozunaData,
  industryData,
  jozunaDuration,
  industryDuration,
  program_description,
  program_title,
  jozuna_title,
  jozuna_description,
  jozuna_program_id,
  industry_program_id,
  programDropdownComponent,
}) => {
  const active = activeTab;
  const cardData = jozunaData;
  const industry = industryData;
  const durationJozuna = jozunaDuration;
  const durationIndustry = industryDuration;

  const navigate = useNavigate();
  // Select the data from the Redux store
  const userData = useSelector((state: RootState) => state.profile.profileKeys);
  const handleJozunaDataClick = (data: any) => {
    navigate("/dashboard/recommendation/jozunaview", {
      state: {
        course_id: data.course_id,
        course_name: data.course_title,
        program_id: jozuna_program_id,
      },
    });
  };

  const handleIndustryDataClick = (data: any) => {
    navigate("/dashboard/learning-room/view-courses", {
      state: {
        course_id: data.course_id,
        course_name: data.course_title,
        program_id: industry_program_id,
        program_description: program_description,
        program_title: program_title,
      },
    });
  };
  return (
    <div className="jozuna-skillup-page">
      <div className="background-image"></div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <div>
          <h1 className="video-page-heading">
            {active === 0 ? jozuna_title : program_title}
          </h1>
          <p className="video-page-content">
            {active === 0 ? jozuna_description : program_description}
          </p>
        </div>
        {programDropdownComponent && <div>{programDropdownComponent}</div>}
      </div>

      {assessmentFound && type === "Jozuna" ? (
        <div className="reco-assessment-not-found-container">
          <img
            src={AssessmentNotFound}
            alt="assessment not found"
            className="assessment-not-image"
          />
          <div className="assessment-not-image-text">
            Please take up an assessment to get a
            <br />
            <span className="assessment-not-image-text-span">
              personalized recommendation
            </span>
          </div>
        </div>
      ) : assessmentFound && type === "Industry" ? (
        <div className="reco-assessment-not-found-container">
          <img
            src={IndustryNotFound}
            alt="assessment not found"
            className="assessment-not-image"
          />
          <div className="assessment-not-image-text">
            No course has been assigned to this program
            <br />
          </div>
        </div>
      ) : (
        <>
          <div className="info">
            <div className="info-container">
              <img src={Specialization} alt="specialization logo" />
              <div className="info-content">
                <h1 className="info-heading">Specialization:</h1>
                <p className="info-heading">
                  {active === 0
                    ? `${cardData?.length || 0} Course Series`
                    : `${industry?.length || 0} Course Series`}
                </p>
              </div>
            </div>
            <div className="info-container">
              <img src={Beginner} alt="Beginner logo" />
              <div className="info-content">
                <h1 className="info-heading">Beginner Level</h1>
                <p className="info-subheading">No prior experience required</p>
              </div>
            </div>
            <div className="info-container">
              <img src={Content} alt="Content logo" />
              <div className="info-content">
                <h1 className="info-heading">
                  {active === 0
                    ? `${jozunaDuration} Hours Content`
                    : `${industryDuration} Hours Content`}
                </h1>
              </div>
            </div>
            <div className="info-container">
              <img src={Schedule} alt="Schedule logo" />
              <div className="info-content">
                <h1 className="info-heading">Flexible Schedule</h1>
                <p className="info-subheading">Learn at your own pace</p>
              </div>
            </div>
          </div>
          <div className="video-content-grid">
            {(active === 0 ? cardData || [] : industry || []).map(
              (data, index) => (
                <div className="card-container" key={index}>
                  <Card
                    className="custom-card"
                    onClick={() => {
                      if (!data.has_videos) return;
                      logActionEvent(
                        analytics_strings.analytics_events.course_viewed,
                        {
                          candidate_id: userData.candidate_id,
                          course_name: data.course_title,
                        },
                      );
                      if (active === 0) {
                        handleJozunaDataClick(data);
                      } else {
                        handleIndustryDataClick(data);
                      }
                    }}
                  >
                    <div className="card-image-container">
                      {data.course_thumbnail !== null &&
                      data.course_thumbnail !== undefined ? (
                        <img
                          alt={data.course_title}
                          src={data.course_thumbnail || "https://pick.com"}
                          className="card-img"
                          onError={(e) =>
                            handleImageErrorCallBack(e, "100%", "160px")
                          }
                        />
                      ) : (
                        <div className="no-thumbnail-placeholder">
                          Thumbnail Image Missing
                        </div>
                      )}
                      {data.is_new && (
                        <img
                          alt="Additional Icon"
                          src={NewIcon}
                          className="additional-image"
                        />
                      )}
                    </div>
                    <CardBody>
                      {/* <CardTitle tag="h5">{data.course_title}</CardTitle> */}
                      <CourseNameTitleTextComponent title={data.course_title} />
                      <CardText>{data.course_description}</CardText>
                      <Button
                        className={`card-button ${
                          !data.has_videos ? "disabled" : ""
                        }`}
                        onClick={() => {
                          //Log the Course Event
                          logActionEvent(
                            analytics_strings.analytics_events.course_viewed,
                            {
                              candidate_id: userData.candidate_id,
                              course_name: data.course_title,
                            },
                          );
                          if (active === 0) {
                            handleJozunaDataClick(data);
                          } else {
                            handleIndustryDataClick(data);
                          }
                        }}
                        disabled={!data.has_videos}
                      >
                        <img src={PlayButton} alt="play button" />
                        <span>{data.completion_status}</span>
                      </Button>
                    </CardBody>
                  </Card>
                </div>
              ),
            )}
          </div>
        </>
      )}
      <br />
    </div>
  );
};

export default JozunaSkillUp;
